export default __webpack_public_path__ + "static/media/flechaCurva1.94ddc108.svg";